<script lang="ts">
	import { format } from 'svelte-i18n';
	import { fade } from 'svelte/transition';
	import { Loader, Text } from '@Shelly/shelly-design-system/index';

	export let icon: string;
	export let label: string;
	export let value: string = '';
	export let status: string = '';
	export let description: string = '';
	export let descriptionValue: string = '';
	export let loading: boolean = false;
	export let descriptionInOneRow: boolean = false;
	export let setLocationAlert: boolean = false;
	export let disableSetLocationAlert: boolean = false;
	export let setLocationAlertTitle: string = '';

	let inDuration = loading ? 400 : 0;

	const onCardKeydown = (event: KeyboardEvent) => {
		if (event.key !== 'Enter' && event.key !== ' ') return;
		event.preventDefault();
		(event.currentTarget as HTMLElement).click();
	};
</script>

<div class="card" role="button" tabindex="0" aria-label={label} on:click on:keydown={onCardKeydown}>
	<div class="card-header">
		<i class={icon}></i>
		<div class="label">
			{label}
		</div>
	</div>
	{#if setLocationAlert}
		<div class="set-location-alert">
			<div class="set-location-alert-title">
				<span>{setLocationAlertTitle}</span>
			</div>
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<!-- svelte-ignore a11y-no-static-element-interactions -->
			<div
				class="set-location-alert-btn"
				style={disableSetLocationAlert ? 'pointer-events: none;opacity: 0.4' : ''}
				on:click
			>
				<i class="icon far fa-map-marker-alt"></i>
				<span class="icon-label"
					>{$format('alert_weather_station_set_location', {
						default: 'Set Location',
					})}</span
				>
			</div>
		</div>
	{:else if loading}
		<div class="loading-card d-flex justify-content-center align-items-center">
			<Loader size="m" />
		</div>
	{:else}
		<div
			class="card-container"
			in:fade={{
				duration: inDuration,
			}}
		>
			<div>
				<div class="value">{value}</div>
				<!-- <Text element="h2" styleType="body" style="font-size: 20px">{value}</Text> -->
				<div class="status">{status}</div>
			</div>
			<div class="card-content">
				<slot name="main" />
			</div>
		</div>
		<div class="card-footer">
			<div class="description d-flex{descriptionInOneRow ? '' : ' flex-wrap'}">
				<span class="description-label">{description}</span>
				<!-- <Text element="span" styleType="body-extra-small" class="mr-xs">{description}</Text> -->
				<span class="description-value">{descriptionValue}</span>
				<!-- <Text element="span" styleType="body-extra-small">{descriptionValue}</Text> -->
			</div>
			<div class="info">
				<slot name="info" />
			</div>
		</div>
	{/if}
</div>

<style>
	.card:hover {
		cursor: pointer;
	}
	.card:focus-visible {
		outline: 2px solid var(--color-primary);
		outline-offset: 2px;
	}
	.loading-card {
		height: 100%;
	}
	.card {
		font-family: var(--font-family);
		background-color: #141719;
		opacity: 90%;
		border-radius: 12px;
		padding: 8px;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		margin: 0 4px 8px;
		height: 180px;
	}
	i {
		font-size: 14px;
		color: #8e8e93;
	}
	.set-location-alert {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		height: 100%;
	}
	.set-location-alert-title {
		padding: 8px;
		color: #ededed;
		font-size: 12px;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		max-height: 90px;
		overflow: hidden;
	}
	.set-location-alert-btn {
		display: flex;
		align-items: center;
		border-radius: 8px;
		border: solid 1px #818588;
		font-size: 12px;
		padding: 8px;
		cursor: pointer;
		max-width: 100%;
	}
	.set-location-alert-btn .icon {
		padding-right: 5px;
		color: #818588;
	}
	.card-header {
		display: flex;
		align-items: center;
		gap: 6px;
		margin-bottom: 6px;
		margin-top: 4px;
	}
	.card-container {
		height: 125px;
		display: flex;
		flex-direction: column;
	}
	.card-content {
		display: flex;
		align-items: center;
		justify-content: end;
		font-size: 32px;
		color: #8e8e93;
		height: 100%;
	}
	.card-footer {
		display: flex;
		flex-direction: column;
		justify-content: end;
		min-height: 20px;
	}
	.label {
		display: flex;
		align-self: center;
		justify-content: center;
		color: #818588;
		font-size: 10px;
		font-weight: bold;
		text-transform: uppercase;
		letter-spacing: 0.8px;
	}
	.status {
		color: #ededed;
		font-size: 16px;
	}
	.value {
		color: #ededed;
		font-size: 20px;
		max-height: 52px;
	}
	.value,
	.icon-label {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		line-clamp: 2;
	}
	.description {
		font-size: 12px;
		color: #ededed;
	}
	.description-label,
	.description-value,
	.info {
		white-space: nowrap;
	}
	.info {
		font-size: 10px;
		color: #8e8e93;
		margin-top: 4px;
	}
	.label,
	.description-label {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		line-clamp: 1;
		margin-right: 4px;
	}
</style>
